<template>
  <!-- 弹窗遮罩层 -->
  <div class="auth-modal-backdrop">
    <!-- 弹窗卡片 -->
    <div class="auth-modal-card">
      <!-- 弹窗头部 -->
      <div class="modal-header">
        <div class="modal-header-content">
          <h2 class="modal-title">Login Account</h2>
          <p class="modal-subtitle">Welcome back, please log in to your account</p>
        </div>
        <button class="close-btn" @click="$emit('close-modal')" aria-label="Close">
          <i class="icon-close">×</i>
        </button>
      </div>

      <!-- 登录表单 -->
      <form class="auth-form" @submit.prevent="handleSubmit" novalidate>
        <div class="form-group">
          <label for="login-email" class="form-label">User Name</label>
          <div class="input-wrapper">
            <i class="icon-email"></i>
            <input 
              type="email" 
              id="login-email" 
              placeholder="Please enter your user name" 
              required
              v-model="formData.email"
              class="form-input"
            >
          </div>
        </div>
        
        <div class="form-group">
          <label for="login-password" class="form-label">Password</label>
          <div class="input-wrapper">
            <i class="icon-lock"></i>
            <input 
              type="password" 
              id="login-password" 
              placeholder="Please enter your password" 
              required
              v-model="formData.password"
              class="form-input"
            >
          </div>
        </div>
        
        <div class="form-options">
          <label class="remember-me">
            <input 
              type="checkbox" 
              v-model="formData.rememberMe"
              class="remember-checkbox"
            >
            <span>Remember Me</span>
          </label>
          <!-- <a href="#" class="forgot-password">Forgot password?</a> -->
        </div>
        
        <button type="submit" class="submit-btn">
          <span>Log In</span>
          <i class="icon-arrow"></i>
        </button>
        
        <!-- 移除“或使用以下方式登录”相关模块（分隔线+社交登录） -->
        
        <!-- <div class="form-switch">
          Don't have an account?
          <button 
            type="button" 
            class="switch-btn" 
            @click="$emit('switch-to-register')"
          >
            Sign Up Now
          </button>
        </div> -->
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      formData: {
        email: '',
        password: '',
        rememberMe: false
      }
    };
  },
  methods: {
    async handleSubmit() {
        try {
          const response = await axios.post('/login', this.formData);
          console.log('Login response:', response.data);

          // 检查后端返回的状态是否成功
          if (response.data.status === 'success' && response.data.user) {
            // 登录成功
            this.$emit('close-modal');
            // 【关键修改】将用户名作为参数随事件一起发出
            this.$emit('login-success', response.data.user);
          } else {
            // 登录失败，可以在这里添加错误提示
            alert(response.data.message || 'Login failed');
          }
        } catch (error) {
          console.error('Login request failed:', error);
          alert('An error occurred during login.');
        }
    }
  }
};
</script>

<style scoped>
/* 弹窗遮罩层 */
.auth-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(10, 25, 47, 0.85);
  backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
}

/* 弹窗卡片 */
.auth-modal-card {
  background: #112240;
  border-radius: 0.75rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 500px;
  border: 1px solid rgba(100, 255, 218, 0.15);
  overflow: hidden;
  transform: translateY(20px);
  animation: slideUp 0.3s ease 0.1s forwards;
}

/* 弹窗头部 */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.75rem 1.75rem 1.5rem;
  border-bottom: 1px solid rgba(100, 255, 218, 0.1);
}

.modal-header-content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.modal-title {
  color: #e6f1ff;
  font-size: 1.6rem;
  margin: 0;
  font-weight: 600;
}

.modal-subtitle {
  color: #8892b0;
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.4;
}

.close-btn {
  background: transparent;
  border: none;
  color: #8892b0;
  font-size: 1.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.close-btn:hover {
  color: #64ffda;
  background: rgba(100, 255, 218, 0.1);
}

/* 表单样式 */
.auth-form {
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.form-label {
  color: #ccd6f6;
  font-size: 0.95rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.input-wrapper {
  position: relative;
}

.form-input {
  width: 100%;
  padding: 0.95rem 1rem 0.95rem 2.75rem;
  border: 1px solid #233554;
  border-radius: 0.375rem;
  background: #0a192f;
  color: #e6f1ff;
  font-size: 1rem;
  transition: all 0.25s ease;
}

.form-input::placeholder {
  color: #4a5568;
  transition: color 0.2s ease;
}

.form-input:focus {
  outline: none;
  border-color: #64ffda;
  box-shadow: 0 0 0 2px rgba(100, 255, 218, 0.2);
}

.form-input:focus::placeholder {
  color: #8892b0;
}

/* 输入框图标 */
.icon-email, .icon-lock {
  position: absolute;
  left: 0.9rem;
  top: 50%;
  transform: translateY(-50%);
  color: #8892b0;
  transition: color 0.2s ease;
}

.form-input:focus ~ .icon-email,
.form-input:focus ~ .icon-lock {
  color: #64ffda;
}

/* 表单选项 */
.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.25rem;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #8892b0;
  font-size: 0.9rem;
  cursor: pointer;
}

.remember-checkbox {
  accent-color: #64ffda;
  width: 16px;
  height: 16px;
}

.forgot-password {
  color: #64ffda;
  font-size: 0.9rem;
  text-decoration: none;
  transition: color 0.2s ease;
  position: relative;
}

.forgot-password::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 0;
  height: 1px;
  background-color: #64ffda;
  transition: width 0.2s ease;
}

.forgot-password:hover {
  color: #4cc9aa;
}

.forgot-password:hover::after {
  width: 100%;
}

/* 提交按钮 */
.submit-btn {
  background: #64ffda;
  color: #0a192f;
  border: none;
  border-radius: 0.375rem;
  padding: 0.95rem 1rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
  margin-top: 0.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  position: relative;
  overflow: hidden;
}

.submit-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: all 0.6s ease;
}

.submit-btn:hover {
  background: #4cc9aa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(100, 255, 218, 0.25);
}

.submit-btn:hover::before {
  left: 100%;
}

/* 移除“或使用以下方式登录”相关样式（分隔线+社交登录） */

/* 切换链接 */
.form-switch {
  color: #8892b0;
  font-size: 0.95rem;
  text-align: center;
  margin-top: 1rem;
  line-height: 1.5;
}

.switch-btn {
  background: transparent;
  border: none;
  color: #64ffda;
  cursor: pointer;
  font-weight: 500;
  padding: 0;
  margin: 0 0 0 0.25rem;
  position: relative;
}

.switch-btn::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 0;
  height: 1px;
  background-color: #64ffda;
  transition: width 0.2s ease;
}

.switch-btn:hover {
  color: #4cc9aa;
}

.switch-btn:hover::after {
  width: 100%;
}

/* 动画 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { transform: translateY(20px); }
  to { transform: translateY(0); }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .auth-modal-card {
    max-width: 100%;
  }
  
  .modal-title {
    font-size: 1.4rem;
  }
  
  .auth-form {
    padding: 1.5rem;
  }
  
  .modal-header {
    padding: 1.5rem;
  }
}
</style>